module.exports = __webpack_public_path__ + "img/QRcode.2a33272f.png";